const ITEMS = [
  "Timeless Elegance",
  "Hand-Poured in India",
  "Pure Botanical Wax",
  "Fine Fragrance Oils",
  "Quiet Luxury",
  "In Every Detail",
];

export const Marquee = () => (
  <section className="overflow-hidden border-y border-gold/15 bg-chocolate py-5" data-testid="brand-marquee" aria-hidden="true">
    <div className="animate-marquee flex w-max whitespace-nowrap">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0 items-center">
          {ITEMS.map((t) => (
            <span key={`${dup}-${t}`} className="flex items-center">
              <span className="px-10 font-serif text-lg font-light italic tracking-wide text-beige/75 md:text-xl">
                {t}
              </span>
              <span className="h-1.5 w-1.5 rotate-45 bg-gold/70" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
